import { useRef, useEffect, useState } from 'react';

const useThrottle = (value, interval = 300) => {
  const [throttleValue, setThrottleValue] = useState(value);
  const startTimeRef = useRef(new Date());

  useEffect(() => {
    let endTime = new Date();
    const startTime = startTimeRef.current;
    let timer;
    const diffTime = endTime - startTime;
    const nextTime = interval - (endTime - startTime);
    if (diffTime >= interval) {
      setThrottleValue(value);
      startTimeRef.current = new Date();
    } else {
      timer = setTimeout(() => {
        setThrottleValue(value);
        startTimeRef.current = new Date();
      }, nextTime);
    }

    return () => {
      clearTimeout(timer);
    };
  }, [value, interval]);

  return throttleValue;
};

export default useThrottle;
